import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FilePortalComponent } from './landing/file-portal.component';
import { FilePortalDataService } from './file-portal-dataservice';
import { SnAuthCallbackComponent, SnAuthGuard } from '@insight/serenity-auth';
import { PersonaGuard } from '../auth/authguards/persona-guard';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClientFilesUploadComponent } from './client-files-upload/client-files-upload.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';

const routes: Routes = [
  { path: 'file-portal', component: FilePortalComponent, canActivate: [SnAuthGuard, PersonaGuard]}
];

@NgModule({
  declarations: [
    FilePortalComponent,
    ClientFilesUploadComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgxDatatableModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedComponentsModule
  ],
  providers: [
    FilePortalDataService
  ]
})
export class FilePortalModule { }
